import React, { useState, useEffect } from "react"
import styled from "styled-components"
import Recaptcha from "react-invisible-recaptcha"
import { colors, breakpoints } from "utils/utils"
import { FaCheckCircle } from "react-icons/fa"
import { MdError } from "react-icons/md"
import Img from "gatsby-image"

let recaptcha = ""
let textFields = {}
let disclaimers = {}
export default props => {
  const [successMessage, setSuccessMessage] = useState("")
  const [errorMessage, setErrorMessage] = useState("")

  const RECAPTCHA_KEY = process.env.SITE_RECAPTCHA_KEY

  const { data, form, lang, close } = props

  const encode = data => {
    return Object.keys(data)
      .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
      .join("&")
  }

  useEffect(() => {
    const checkField = elem => {
      if (!elem.classList.contains("hidden") && elem.required) {
        if (elem.type !== "checkbox" && elem.value === "") {
          if (lang === "en") {
            elem.setCustomValidity("Please fill out this field")
          } else {
            elem.setCustomValidity("Completa este campo")
          }
        } else if (elem.type === "checkbox" && !elem.checked) {
          if (lang === "en") {
            elem.setCustomValidity(
              "Please check this box if you want to proceed"
            )
          } else {
            elem.setCustomValidity("Marque esta casilla si desea continuar")
          }
        } else if (!elem.validity.valid && elem.type === "email") {
          if (lang === "en") {
            elem.setCustomValidity("Wrong email format")
          } else {
            elem.setCustomValidity("Formato de email incorrecto")
          }
        } else {
          elem.setCustomValidity("")
        }
      }
    }

    let inputs = document.querySelectorAll("form input")
    inputs.forEach(input => {
      input.addEventListener("invalid", e => checkField(e.target))
      input.addEventListener("input", e => e.target.setCustomValidity(""))
    })

    return () => {
      inputs.forEach(input => {
        input.removeEventListener("invalid", e => checkField(e.target))
        input.removeEventListener("input", e => e.target.setCustomValidity(""))
      })
    }
  }, [lang])

  const checkEmailFormat = elem => {
    if (!elem.validity.valid && elem.value !== "") {
      if (lang === "en") {
        elem.setCustomValidity("Wrong email format")
      } else {
        elem.setCustomValidity("Formato de email incorrecto")
      }
    }
  }

  const checkCustomerName = e => {
    const customerName = e.target.value.trim()
    if (customerName === "" && e.charCode === 32) {
      e.preventDefault()
    } else {
      handleTextFieldChange(e)
    }
  }

  const handleFormSubmit = e => {
    e.preventDefault()
    recaptcha.execute()
  }

  const handleTextFieldChange = e => {
    let tempObj = { ...textFields }
    tempObj[`${e.target.name}`] = e.target.value.trim()
    textFields = { ...tempObj }
  }

  const handleCheckboxChange = e => {
    let tempObj = { ...disclaimers }
    tempObj[`${e.target.id}`] = e.target.checked
    disclaimers = { ...tempObj }
  }

  const onRecaptchaResolved = () => {
    const path = window && window.location ? window.location.pathname : "/"
    fetch(path, {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({
        "form-name": "bucases",
        "bucase-name": data.name,
        "g-recaptcha-response": recaptcha.getResponse(),
        ...textFields,
        ...disclaimers,
      }),
    })
      .then(() => {
        fetch(data.pdf.file.url, {
          method: "GET",
          headers: new Headers({
            access_token: process.env.CONTENTFUL_ACCESS_TOKEN,
          }),
        })
          .then(response => response.blob())
          .then(blob => {
            var url = window.URL.createObjectURL(blob)
            var a = document.createElement("a")
            a.href = url
            a.download = `${data.pdf.file.fileName}.pdf`
            document.body.appendChild(a)
            a.click()
            a.remove()
            setSuccessMessage(form.successMessage)
          })
      })
      .catch(error => {
        console.warn(error)
        setErrorMessage(form.errorMessage)
      })
  }

  return (
    <>
      {!errorMessage && !successMessage ? (
        <BCPopup>
          <Title>{data.name}</Title>
          <FormBlock>
            <Form
              id="bucases"
              name="bucases"
              method="post"
              action="/"
              data-netlify="true"
              data-netlify-honeypot="field-bot-detection"
              data-netlify-recaptcha="true"
              onSubmit={handleFormSubmit}
              lang={lang}
            >
              <input type="hidden" name="form-name" value="bucases" />
              <input type="hidden" name="bucase-name" value={`${data.name}`} />
              <input
                name="field-bot-detection"
                onChange={handleTextFieldChange}
                className="hidden"
              />
              {form.formTextField.map((textfield, index) => (
                <InputBlock key={index}>
                  <Label htmlFor={textfield.htmlid}>
                    {textfield.label}{" "}
                    {textfield.required && <Required>*</Required>}
                  </Label>
                  <Input
                    type={textfield.type}
                    id={textfield.htmlid}
                    name={textfield.htmlid}
                    onKeyDown={e =>
                      textfield.type === "email" && checkEmailFormat(e.target)
                    }
                    onKeyUp={e =>
                      textfield.type === "email" && checkEmailFormat(e.target)
                    }
                    onKeyPress={
                      textfield.type === "text" ? checkCustomerName : null
                    }
                    onChange={
                      textfield.type === "email" ? handleTextFieldChange : null
                    }
                    required={textfield.required}
                  />
                </InputBlock>
              ))}
              {form.disclaimer &&
                form.disclaimer.map((disclaimer, index) => (
                  <Disclaimer key={index}>
                    <Checkbox
                      type="checkbox"
                      id={disclaimer.htmlid}
                      name={disclaimer.htmlid}
                      value={disclaimer.htmlid}
                      onChange={handleCheckboxChange}
                      required={disclaimer.required}
                    />
                    <CheckboxLabel htmlFor={disclaimer.htmlid}>
                      {disclaimer.text.text}
                    </CheckboxLabel>
                  </Disclaimer>
                ))}
              <FormCTActions>
                <Recaptcha
                  ref={ref => (recaptcha = ref)}
                  sitekey={RECAPTCHA_KEY}
                  onResolved={onRecaptchaResolved}
                  locale={lang}
                  badge="inline"
                />
                <Button id="submitForm" name="submitForm" type="submit">
                  {form.button}
                </Button>
              </FormCTActions>
            </Form>
            <ImageBlock>
              {data.background && (
                <Image fluid={data.background.fluid} alt={data.name} />
              )}
            </ImageBlock>
          </FormBlock>
        </BCPopup>
      ) : errorMessage ? (
        <ErrorMessage onClick={() => close()}>
          <MdError />
          <Message>{errorMessage}</Message>
        </ErrorMessage>
      ) : (
        <SuccessMessage onClick={() => close()}>
          <FaCheckCircle />
          <Message>{successMessage}</Message>
        </SuccessMessage>
      )}
    </>
  )
}

const Message = styled.span`
  align-self: center;
  ${breakpoints.sm} {
    font-size: 1.5rem;
  }
`

const ErrorMessage = styled.button`
  border: unset;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: ${colors.quinary};
  color: ${colors.error};
  min-width: 20rem;
  min-height: 20rem;
  padding: 1.5rem 2.5rem;
  border-radius: 1rem;
  font-weight: 700;
  overflow-y: auto;

  ${breakpoints.sm} {
    min-width: unset;
    min-height: unset;
    width: 100vw;
    height: 100vh;
    margin: auto;
    height: fill-available;
  }

  svg {
    width: 5rem;
    height: 5rem;
    align-self: center;
    margin: 1rem 3rem 3rem;
  }
`

const SuccessMessage = styled.button`
  border: unset;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: ${colors.quinary};
  color: ${colors.success};
  min-width: 20rem;
  min-height: 20rem;
  padding: 1.5rem 2.5rem;
  border-radius: 1rem;
  font-weight: 700;
  overflow-y: auto;

  ${breakpoints.sm} {
    min-width: unset;
    min-height: unset;
    width: 100vw;
    height: 100vh;
    margin: auto;
    height: fill-available;
  }

  svg {
    width: 5rem;
    height: 5rem;
    align-self: center;
    margin: 1rem 3rem 3rem;
  }
`

const BCPopup = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: ${colors.quinary};
  color: ${colors.quaternary};
  min-width: 54rem;
  padding: 1.5rem 2.5rem;
  border-radius: 1rem;
  font-weight: 700;
  overflow-y: auto;

  ${breakpoints.md} {
    min-width: 35rem;
  }

  ${breakpoints.sm} {
    min-width: unset;
    width: 100vw;
    height: 100vh;
    margin: auto;
    height: fill-available;
  }
`

const FormCTActions = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  .grecaptcha-badge {
    margin: 1rem 0 auto auto;
  }
`

const Title = styled.h2`
  text-align: center;
  text-transform: uppercase;
`

const FormBlock = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  border-top: solid 0.15rem ${colors.quaternary};
  padding-bottom: 5rem;
  ${breakpoints.md} {
    flex-direction: column;
    padding-bottom: unset;
  }
`
const Form = styled.form`
  display: flex;
  flex-direction: column;
  border-right: solid 0.1rem ${colors.quaternary};
  width: 50%;
  height: 100%;
  padding-top: 0.8rem;
  align-items: center;
  ${breakpoints.md} {
    width: 100%;
    border-right: none;
  }
`

const ImageBlock = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-left: solid 0.1rem ${colors.quaternary};
  ${breakpoints.md} {
    display: none;
  }
`

const Image = styled(Img)`
  width: 15rem;
  height: auto;
  margin: auto;
`

const InputBlock = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0.5rem 0;
  font-weight: 700;
  ${breakpoints.md} {
    width: 100%;
  }
`
const Label = styled.label`
  min-width: 8rem;
  margin: auto 0;
`

const Input = styled.input`
  width: auto;
  padding: 0.4rem;
  background-color: transparent;
  border: solid 0.1rem ${colors.quaternary};
  ${breakpoints.md} {
    width: 100%;
  }
`

const Required = styled.span`
  color: red;
`
const Disclaimer = styled.div`
  margin-top: 0.7rem;
  width: 19rem;
  ${breakpoints.md} {
    width: 100%;
  }
`

const Checkbox = styled.input`
  margin-right: 0.7rem;
  ${breakpoints.md} {
    vertical-align: text-bottom;
  }
`

const CheckboxLabel = styled.label``

const Button = styled.button`
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  padding: 0.3rem 1.5rem;
  width: auto;
  height: 3rem;
  border-radius: 0.7rem;
  border: none;
  color: ${colors.quinary};
  background-color: ${colors.secondary};
  cursor: pointer;

  ${breakpoints.md} {
    position: unset;
    transform: none;
    margin-top: 2rem;
  }
`
